import { render, staticRenderFns } from "./PcFooter.vue?vue&type=template&id=ccf4d120&scoped=true"
import script from "./PcFooter.vue?vue&type=script&lang=js"
export * from "./PcFooter.vue?vue&type=script&lang=js"
import style0 from "./PcFooter.vue?vue&type=style&index=0&id=ccf4d120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4d120",
  null
  
)

export default component.exports